import { Component } from '@angular/core';

@Component({
    selector: 'app-cancel-sub-dialog',
    templateUrl: './cancel-sub-dialog.component.html',
    styleUrls: ['./cancel-sub-dialog.component.scss'],
    standalone: false
})
export class CancelSubDialogComponent {

}
